module.exports = __webpack_public_path__ + "fcef39073e3cb693d8f44ea5cb42ef01.png";